(function(){
  function currentGroup(){
    var i = document.querySelector('variant-selects input:checked, variant-radios input:checked, .product-form__input input:checked');
    var v = i ? (i.value||'') : '';
    if(!v){ var s = document.querySelector('variant-selects select, .product-form__input select'); if(s) v = s.value||''; }
    v = v.toLowerCase();
    if(v.indexOf('inox') > -1) return 'inox';
    if(v.indexOf('sort') > -1) return 'sort';
    return null;
  }
  function apply(){
    var g = currentGroup(); if(!g) return;
    var other = g === 'inox' ? '-sort-' : '-inox-';
    var items = document.querySelectorAll('.product__media-item, .thumbnail-list__item');
    items.forEach(function(li){
      var img = li.querySelector('img'); if(!img) return;
      var s = (img.currentSrc||'') + ' ' + (img.src||'') + ' ' + (img.srcset||'');
      var want = s.indexOf(other) > -1 ? 'none' : '';
      if(li.style.display !== want) li.style.display = want;
    });
  }
  document.addEventListener('change', function(e){
    if(e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) setTimeout(apply, 200);
  });
  var t; new MutationObserver(function(){ clearTimeout(t); t = setTimeout(apply, 150); }).observe(document.documentElement, {subtree:true, childList:true});
  if(document.readyState !== 'loading') setTimeout(apply, 100); else document.addEventListener('DOMContentLoaded', function(){ setTimeout(apply, 100); });
})();